import React from "react";

type Props = {
  options: {
    toRender: JSX.Element;
    onClick: () => void;
  }[];
};

function SCP_Util({ options }: Props) {
  return (
    <div className="SCP_Util">
      {options.map((option, index) => (
        <div className="SCP_Clear" key={index} onClick={option.onClick}>
          {option.toRender}
        </div>
      ))}
    </div>
  );
}

export default SCP_Util;
